.root {
    grid-column: content;
    position: relative;

    & > :first-child {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
    }

    & > img {
        height: auto;
    }

    &::before {
        content: "";
        display: block;
        padding-bottom: calc(100% / (var(--aspect-ratio)));
    }
}
